import styled from 'styled-components';
import {
  Icon as SemanticIcon,
} from 'semantic-ui-react';
import { Text } from '@playbookux/playbook-web-core';

export const Icon = styled(SemanticIcon)``;

export const TableCardValue = styled(Text)`
  flex: 1;
`;

export const ContainerAccordion = styled.div`
  display: flex;
  color: ${(props) => props.theme.color.primary}; 
  cursor: pointer;
`;

export const RemainingText = styled.a``;

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
`;
